import axios from 'axios';
import { cp } from 'fs';

export const getBaseUrl = () => {
  let baseUrl = 'https://adminportalenapi.tradesolution.no/api';
  if (window.location.host.indexOf('dev') > -1)
    baseUrl = 'https://adminportalenapi-dev.tradesolution.no/api';

  if (window.location.host.indexOf('localhost') > -1)
    baseUrl = 'https://adminportalenapi-dev.tradesolution.no/api';
  //baseUrl = 'https://localhost:7216/api';

  return baseUrl;
};

export interface AiResponse {
  gln: string;
  organisasjonsnummer: string;
  telefonnummer: string;
  besoksadresse: string;
  nedlagtdato: string;
  enhetnavn: string;
  butikknummer: string;
  firmanavn: string;
  besokpostnummer: string;
  besokpoststed: string;
  fakturaadresse: string;
  fakturapostnummer: string;
  fakturapoststed: string;
  postadresse: string;
  postnummer: string;
  postpoststed: string;
  kommentar: string;
  leverandorkundenummer: string;
  leverandorkundenummerhos: string;
  leverandorkundenummerhostskundeid: string;
  kundenummerhossgrossist: string;
  bransjeforslag: string;
  kontonummer: string;
  oppstartsdato: string;
  omsetning: string;
  salgsareal: string;
  fakturaEpost: string;
  butikkEpost: string;

  //kjede fields
  markedskjede: string;
  markedskjedeNr: string;
  regionalkjede: string;
  regionalkjedeNr: string;

  MedlemHos: string;
  MedlemHosInnmeldingsdato: string;
}

function parseMedlemshosInfo(data: string): any {
  // parse t.ex. EXTRA (33), 33 is Kjedenr, Extra is Kjedenavn
  const kjedeRegex = /^(.*) \((\d+)\)$/;
  const match = data.match(kjedeRegex);
  if (match) {
    const kjedenavn = match[1].trim();
    const kjedenr = match[2].trim();
    return {
      kjedenavn: kjedenavn,
      kjedeNr: kjedenr,
    };
  }
}

const AiApi = {
  ask: async (prompt: string): Promise<AiResponse> => {
    const payload = {
      prompt: prompt,
    };
    const response = await axios.post(getBaseUrl() + '/ai', payload);

    let json: AiResponse;
    try {
      if (typeof response.data === 'string') {
        const medlemshosInfo = parseMedlemshosInfo(response.data);
        json = {
          markedskjede: medlemshosInfo?.kjedenavn || '',
          markedskjedeNr: medlemshosInfo?.kjedeNr || '',
          regionalkjede: medlemshosInfo?.kjedenavn || '',
          regionalkjedeNr: medlemshosInfo?.kjedeNr || '',
          gln: '',
          organisasjonsnummer: '',
          telefonnummer: '',
          besoksadresse: '',
          nedlagtdato: null,
          enhetnavn: '',
          butikknummer: '',
          firmanavn: '',
          besokpostnummer: '',
          besokpoststed: '',
          fakturaadresse: '',
          fakturapostnummer: '',
          fakturapoststed: '',
          postadresse: '',
          postnummer: '',
          postpoststed: '',
          kommentar: '',
          leverandorkundenummer: '',
          leverandorkundenummerhos: '',
          leverandorkundenummerhostskundeid: '',
          kundenummerhossgrossist: '',
          bransjeforslag: '',
          kontonummer: '',
          salgsareal: '0',
          fakturaEpost: '',
          oppstartsdato: null,
          omsetning: '',
          butikkEpost: '',
          MedlemHos: medlemshosInfo?.kjedenavn || '',
          MedlemHosInnmeldingsdato: null,
        };

        //json = JSON.parse(response.data);
      } else {
        json = response.data;
      }
      return json;
    } catch (e) {
      console.error('parsing of json failed: ' + response.data);
    }
  },
};
export default AiApi;
